<template>
  <div class="w-full h-full px-4 pb-5 box-border flex flex-col overflow-hidden">
    <header class="w-full py-1 flex items-center justify-between">
      <div class="flex items-center overflow-hidden">
        <label class="text-medium text-theme-black-850">维度分值计算方式：</label>
        <el-radio-group
          class="mt-0.5"
          :disabled="switchLoading"
          v-model="topSource.computeMode"
          @change="switchRadioHandle"
        >
          <el-radio :label="0">
            <span class="text-medium text-theme-black-650">求和</span>
            <span class="text-small text-theme-black-450">(题目分数之和)</span>
          </el-radio>
          <el-radio :label="1">
            <span class="text-medium text-theme-black-650">平均分</span>
            <span class="text-small text-theme-black-450">(题目分数之和/题目数)</span>
          </el-radio>
        </el-radio-group>
      </div>
      <el-button type="primary" size="small" @click="bindHandle">题目绑定</el-button>
    </header>
    <div class="flex-1 overflow-hidden">
      <data-table
        ref="dataTable"
        class="sms_table w-full h-full overflow-hidden"
        cell-class-name="truncate-table-cell-wrap"
        align="left"
        height="100%"
        :data="list"
        :loading="tableLoading"
        :columns="columns"
        :show-page="false"
        :show-tooltip="true"
        index
      >
        <template #content="{ row }">
          <div class="w-full" v-if="row.content.length > 0">
            <div
              v-for="cont of row.content"
              :key="cont.key"
              class="w-full truncate"
            >{{cont.orderIndex}}.{{cont.text}}</div>
          </div>
        </template>
      </data-table>
    </div>
  </div>
</template>

<script>
import { createPopup } from '@/assets/js/factory'
import DataTable from '@/components/base/DataTable'
import { editDimensionScore, getTopicBinds, getStandardScoreWeightSettings } from '@/api/wenjuan/dimensionScore'
import TopicBindDialog from './TopicBindDialog'
import { topicBindColumns } from '../../config/dimension-score'

export default {
  name: 'TopicBind',
  components: {
    DataTable
  },
  inject: {
    topSource: {
      default: () => ({})
    }
  },
  data() {
    return {
      list: [],
      tableLoading: false,
      columns: topicBindColumns,
      switchLoading: false,
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      getTopicBinds().then(res => {
        const list = res?.data?.data || [];
        this.list = list.map(m => {
          const [name, questions] = Object.entries(m)[0];
          const qs = questions || [];
          return {
            name,
            count: qs.length,
            content: qs.map((m,i) => {
              const item = { text: m.content.text };
              const questionList = this.topSource.questions || [];
              const defKey = Date.now();
              const { orderIndex = '' } = questionList.find(f => f.id === m.id) || { orderIndex: '' };
              item.key = defKey + i * 1000;
              item.orderIndex = orderIndex;
              return item;
            }).sort((a,b) => a.orderIndex - b.orderIndex),
            questions: qs,
          }
        });
      }).catch(() => {
        this.$message.error('获取题目绑定列表失败');
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    switchRadioHandle() {
      const req = {
        computeMode: this.topSource.computeMode
      };
      this.switchLoading = true;
      editDimensionScore(req, req).then((res) => {
        const { code, msg } = res.data || {};
        if (code === 0) {
          this.$message.success('切换维度计算方式成功');
          this.flushScoreList();
        } else {
          this.$message.error(msg ?? '切换维度计算方式失败');
        }
      }).catch(() => {
        this.$message.error('切换维度计算方式失败');
      }).finally(() => {
        this.switchLoading = false;
      });
    },
    flushScoreList() {
      getStandardScoreWeightSettings()
        .then(res => {
          const { code, msg } = res.data || {};
          if (code === 1) {
            this.$message.error(msg ?? '更新分数失败');
          }
        })
        .catch(() => {
          this.$message.error('更新分数失败');
        });
    },
    bindHandle() {
      createPopup(TopicBindDialog, {
        questions: this.topSource.questions || [],
        dimensions: this.list,
        onSuccess: this.bindHandleSuccess
      });
    },
    bindHandleSuccess({ dimensions }) {
      if (dimensions.length > 0) {
        this.getList();
      } else {
        this.topSource.active = 0;
        this.topSource.currentView = 1;
      }
    }
  }
}
</script>